<template>
  <div>
    <div class="app-body" ref="body">
      <div class="user-headpic" @click="doLogins">
        <div class="headpic">
          <img :src="headImage">
        </div>
        <div class="infos">
          <div>{{ member.nickname || member.name || '点击登录' }}</div>
          <div>会员ID：{{ member.code }}</div>
        </div>
        <div class="links">
          <van-icon name="arrow" />
        </div>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="user-cards">
          <div class="user-card" :style="cardBg" @click="show = true">
            <div class="imgs">
              <img :src="sitelogo" style="display:block; height:2rem;">
              <div class="name">小记者会员卡</div>
            </div>
            <div class="names">{{ member.nickname || member.name }}</div>
            <div class="code">{{ member.code }}</div>
            <div class="qrcode"><van-icon name="qr" /></div>
          </div>
        </div>
        <van-row class="user-links">
          <van-col span="6" @click="goOrder(0)">
            <van-icon name="pending-payment" :info="obj.count0 ? obj.count0 : null" />
            待付款
          </van-col>
          <van-col span="6" @click="goOrder(1)">
            <van-icon name="gold-coin-o" />
            已支付
          </van-col>
          <van-col span="6" @click="goOrder(2)">
            <van-icon name="smile-o" :info="obj.count2 ? obj.count2 : null" />
            已报名
          </van-col>
          <van-col span="6" @click="goOrder(3)">
            <van-icon name="passed" :info="obj.count3 ? obj.count3 : null" />
            已完成
          </van-col>
        </van-row>

        <van-cell-group class="user-group">
          <van-cell icon="records" title="全部订单" to="/orders" is-link />
        </van-cell-group>

        <van-cell-group>
          <!-- <van-cell icon="shopping-cart-o" to="/cart" title="我的购物车" info="3" is-link>
            <van-tag round type="danger">3</van-tag>
          </van-cell> -->
          <!-- <van-cell icon="points" title="我的积分" is-link />
          <van-cell icon="coupon-o" title="我的优惠券" is-link />
          <van-cell icon="gift-o" title="我收到的礼物" is-link /> -->
        </van-cell-group>

        <!-- <van-cell-group>
          <van-cell icon="close" class="user-close" @click="doLogoutShop" title="退出登录" info="3" is-link>
          </van-cell>
        </van-cell-group> -->
      </van-pull-refresh>
      <!-- <div class="wx_account">
        <div class="box" @click="show = !subscribe">
          <van-icon class-prefix="iconfont icon" name="weixin-copy" />
          <div class="title">关注公众号<br>订单随时查</div>
        </div>
      </div> -->
    </div>
    <!-- <van-popup v-model="show" :close-on-click-overlay="false" closeable class="wx_popup">
      <img :src="assetsPath + 'static/images/qrcode.jpg'" />
      <div class="text-center">长按识别二维码</div>
    </van-popup> -->
    <van-dialog
      v-model="show"
      title="会员卡二维码"
      :show-confirm-button="false"
      :closeOnClickOverlay="true"
    >
      <div style="padding:1rem; text-align:center;"><img :src="qrcodeUrl" ><br>{{ member.code }}</div>
    </van-dialog>
    <AppFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import AppFooter from '../app-footer';
import tools from '@/utils/tools';
import QRCode from 'qrcode';
export default {
  mixins: [tools],
  components: {
    AppFooter
  },
  data () {
    return {
      isLoading: false,
      obj: {},
      show: false,
      subscribe: 0,
      qrcodeUrl: null,
      w: 0
    }
  },
  computed: {
    ...mapGetters({
      settings: 'settings',
      reloadWebUser: [types.OTHER.reloadWebUser]
    }),
    posterStyle() {
      return {'background-image':'url('+ this.headImage +')'};
    },
    cardBg() {
      console.log(this.settings)
      let cardbg = this.settings.cardbg;
      if (cardbg) {
        cardbg = this.rootPath + cardbg;
      } else {
        cardbg = this.assetsPath +'static/images/card.jpg';
      }

      return {'background-image':'url('+ cardbg +')'};
    },
    headImage() {
      let image = this.noimg;
      if (this.member.headpic) {
        if (this.member.headpic.isUrl()) {
          image = this.member.headpic;
        } else {
          image = this.rootPath + this.member.headpic;
        }
      }
      return image;
    }
  },
  watch: {
    reloadWebUser() {
      this.getData();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.show) {
      this.show = false;
      next(false);
    } else {
      next();
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
    this.drawQrcode();
  },
  activated() {
    if (!this.obj.countall) {
      this.getData();
    }
    if (!this.w) {
      this.getImgW();
    }
  },
  methods: {
    getData(callback) {
      this.doGet({
        url: 'vue/personal',
        okcb: (json) => {
          this.obj = json.obj;
          this.subscribe = json.subscribe;
          if (callback) {
            callback(json);
          }
        },
        cb: () => {

        }
      })
    },
    drawQrcode() {
      this.qrcodeUrl = '';
      let text = '15002160';
      QRCode.toDataURL(text, {margin:1, width:130, height:130, color:{light:'#FFFFFFCC'}})
        .then(url => {
          // console.log(url)
          this.qrcodeUrl = url;
        })
        .catch(err => {
          // console.error(err)
        });
    },
    doLogins() {
      if (!this.member.id) {
        this.doLogin();
      } else {
        this.$router.push('/user/detail');
      }
    },
    onRefresh() {
      this.isLoading = true;
      this.getData(() => {
        this.$toast('刷新成功');
        this.isLoading = false;
      });
    },
    goOrder(type) {
      let url = '/orders';

      if (type != null) {
        url += '/'+ type;
      }

      this.$router.push(url);
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
  }
};
</script>

<style lang="less" scoped>
@import '//at.alicdn.com/t/font_919761_cgylur06gh.css';
.app-body {
  padding-bottom:5rem;
}
.user {
  &-headpic {
    .flex-center-v();
    padding:1rem 1rem;
    border-bottom:1px #eee solid;
    .headpic {
      width:22vw;
      height:22vw;
      overflow:hidden;
      border:1px #fff solid;
      border-radius:50%;
      background-color:#f5f5f5;
      img {
        display:block;
        width:100%;
        height:100%;
        object-fit:cover;
      }
    }
    .infos {
      flex-grow:1;
      margin-left:.8rem;
      padding-top:.5rem;
      .fontsize(1rem);
      color:#333;
      text-shadow:5px 2px 6px #fff;
    }
    .links {
      .fontsize(1.5rem);
      line-height:1rem;
    }
  }
  &-cards {
    margin:1rem 1rem 0;
  }
  &-card {
    position:relative;
    height:46.8vw;
    background-color:#eee;
    overflow:hidden;
    border-radius:1rem;
    background-repeat:no-repeat;
    background-size:cover;
    color:#FFF;
    .imgs {
      position:absolute;
      top:.5rem;
      left:.5rem;
      width:100%;
      .flex-center-v();
      .name {
        margin-left:.5rem;
      }
    }
    .names {
      position:absolute;
      top:50%;
      left:50%;
      transform:translate(-50%, -50%);
      font-size:1.15rem;
    }
    .code {
      position:absolute;
      left:.5rem;
      bottom:.5rem;
      font-size:1.1rem;
      text-shadow:1px 1px 0 #000;
    }
    .qrcode {
      position:absolute;
      right:.5rem;
      bottom:.5rem;
      font-size:3rem;
      line-height:2rem;
    }
  }
  &-group {
    margin-bottom:1rem;
  }
  &-links {
    position:relative;
    z-index:1;
    padding:1.5rem 0 1rem;
    font-size:.95rem;
    text-align: center;
    color:#444;
    background-color: #fff;
    .van-col {
      .flex-column();
    }
    .van-icon {
      .fontsize(1.6rem);
      color:@bluecolor;
      .van-info {
        right:50%;
        transform:translateX(1.5rem);
      }
    }
  }
  &-close {
    font-weight:bold;
    color:#8C32DD;
  }
}
.wx_account {
  position: fixed;
  right:0;
  bottom:4rem;
  z-index:999;
  .flex();
  justify-content:flex-end;
  .icon {
    .fontsize(3rem);
    color:green;
  }
  .box {
    .flex-center-v();
    flex-direction:column;
    padding:.35rem;
    .bg-white(.8);
    border-radius:.5rem;
    .shadow_blur_black(15px, .35);
  }
}
.wx_popup {
  padding:1rem;
  /deep/ .van-popup__close-icon{
    top:2px;
    right:2px;
  }
}
@media screen {
  @media (min-width:@appwidth) {
    .user {
      &-poster {
        height:@appwidth / 2;
      }
      &-headpic {
        top:200px;
        .headpic {
          width:150px;
          height:150px;
        }
      }
    }
  }
}
  
</style>